// function to get the cased brand name
export const getCorrectlyCasedBrandName = (brand: Brand): string => {
  const brandCasingMap: Record<Brand, string> = {
    seek: 'SEEK',
    jobsdb: 'JobsDB',
    jobstreet: 'Jobstreet',
  };
  return brandCasingMap[brand];
};

// Exporting to maintain consistency
export type Brand = 'seek' | 'jobsdb' | 'jobstreet';
